/*
 * <featured-variant-preselect>
 *
 * On initial product page load, selects the merchant's "featured" variant
 * (product metafield custom.featured_variant) by driving the existing
 * <variant-selects> option inputs and letting the theme's native variant-change
 * machinery update price, media and buy buttons.
 *
 * Only runs when the URL has no explicit ?variant= param, so links that already
 * target a specific variant (e.g. collection swatches) are respected.
 */
class FeaturedVariantPreselect extends HTMLElement {
  connectedCallback() {
    if (new URLSearchParams(window.location.search).has('variant')) return;

    // Wait until <variant-selects> is defined so its change listener is active.
    customElements.whenDefined('variant-selects').then(() => this.preselect());
  }

  preselect() {
    let options;
    try {
      options = JSON.parse(this.dataset.options || '{}');
    } catch (error) {
      return;
    }

    const root = this.closest('variant-selects');
    if (!root) return;

    Object.entries(options).forEach(([name, value]) => {
      const fieldset = root.querySelector(`[data-option-name="${CSS.escape(name)}"]`);
      if (!fieldset) return;

      // Dropdown / swatch_dropdown picker
      const select = fieldset.querySelector('select');
      if (select) {
        if (select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      // Swatch / button (radio) picker
      const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
        (el) => el.value === value
      );
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
}

customElements.define('featured-variant-preselect', FeaturedVariantPreselect);
